import gql from 'graphql-tag';

const key = `CreateCognitoUser`;
const mutation = gql`
mutation ${key}($Username:String!, $TemporaryPassword:String!, $Group:String!) {
  createCognitoUser(Username: $Username, TemporaryPassword: $TemporaryPassword, Group: $Group) {
    Username
    Email
  } 
}
`;

export const CREATE_COGNITO_USER = { key, mutation };
